import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./WhyChooseUs.css";

gsap.registerPlugin(ScrollTrigger);

function WhyChooseUs() {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    gsap.fromTo(
      headingRef.current,
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: headingRef.current,
          start: "top 85%",
          toggleActions: "play none none reverse",
        },
      }
    );

    gsap.fromTo(
      cardsRef.current,
      { y: 80, opacity: 0, scale: 0.9 },
      {
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.8,
        stagger: 0.15,
        ease: "back.out(1.7)",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);

  const values = [
    {
      icon: "fa-lightbulb",
      title: "Innovation",
      description:
        "We continuously strive for innovative solutions that drive progress and deliver exceptional results for every project we take on.",
      image:
        "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&q=80",
      featured: true,
    },
    {
      icon: "fa-heart",
      title: "Customer Centric",
      description:
        "Our customers are at the center of everything we do. We prioritize their needs and satisfaction above all.",
      image:
        "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&q=80",
      featured: false,
    },
    {
      icon: "fa-handshake",
      title: "Integrity",
      description:
        "We uphold the highest standards of honesty and ethical behavior in every interaction.",
      image:
        "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80",
      featured: false,
    },
  ];

  return (
    <section
      ref={sectionRef}
      className="why-choose-section"
      style={{ background: "#f7f7f7", position: "relative", overflow: "hidden" }}
      id="why-choose-us"
    >
      <div className="why-bg-decoration"></div>

      <Container className="position-relative" style={{ zIndex: 2 }}>
        {/* Header */}
        <div ref={headingRef} className="text-center mb-5">
          <h2
            className="text-4xl md:text-5xl font-bold mb-3"
            style={{ color: "#0F0C1F" }}
          >
            Why Choose Us
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Built on a foundation of innovation, customer focus, and unwavering
            integrity
          </p>
        </div>

        {/* Bento Grid */}
        <div className="wcu-grid">
          {values.map((value, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className={`wcu-card ${value.featured ? "wcu-card--featured" : ""}`}
            >
              {/* Hover image */}
              <div
                className="wcu-card-image"
                style={{ backgroundImage: `url(${value.image})` }}
              ></div>

              {/* Dark overlay on hover */}
              <div className="wcu-card-overlay"></div>

              {/* Content (always visible) */}
              <div className="wcu-card-content">
                <div
                  className="wcu-card-icon"
                >
                  <i className={`fa-regular ${value.icon}`}></i>
                </div>
                <h3 className="wcu-card-title">{value.title}</h3>
                <p className="wcu-card-desc">{value.description}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default WhyChooseUs;